let mapper_options = {
  endpoint: 'ad_runs',
  recordClass: require('./record'),
  relations: {
    belongsTo: {
      campaign: {
        foreignKey: 'campaign_id',
        localField: 'campaign'
      },
      retailer: {
        foreignKey: 'retailer_id',
        localField: 'retailer'
      }
    },
    hasMany: {
      ad_run_task: {
        foreignKey: 'ad_run_id',
        localField: 'ad_run_tasks'
      }
    }
  }
}

module.exports = (store) => {
  store.defineMapper('ad_run', mapper_options)
}